import { createContext, useContext } from "react";

import LNIRootStore, { LNIRootStoreInstance } from "./LNIRootStore";
/**
 * Create a context we can use to
 * - Provide access to our stores from our root component
 * - Consume stores in our screens (or other components, though it's
 *   preferable to just connect screens)
 */
const LNIRootStoreContext = createContext(LNIRootStore);

/**
 * The provider our root component will use to expose the root store
 */
export const LNIRootStoreProvider = LNIRootStoreContext.Provider;

/**
 * A hook that screens can use to gain access to our stores, with
 * `const { someStore, someOtherStore } = useStores()`,
 * or less likely: `const LNIrootStore = useStores()`
 */
export const useLNIStores = (): LNIRootStoreInstance => useContext(LNIRootStoreContext);

export { default as LNIRootStore } from "./LNIRootStore";
